import zod from 'zod';

export const ServerFarmDetailSchema = zod.object({
    id: zod.coerce.number(),
});
